import React, { useEffect, useState, useCallback } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import Logo from '../Logo/Logo';
import '../../styles/navbar.css';

const LINKS = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'why', label: 'Why Us' },
  { id: 'process', label: 'Process' },
  { id: 'certification', label: 'Certification' },
  { id: 'stories', label: 'Gallery' },
  { id: 'contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('home');

  const onScroll = useCallback(() => {
    setScrolled(window.scrollY > 40);

    // Scroll spy — find the section currently in view
    const offset = window.scrollY + 120;
    let current = 'home';
    LINKS.forEach((link) => {
      const el = document.getElementById(link.id);
      if (el && el.offsetTop <= offset) current = link.id;
    });
    setActive(current);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  // Lock body scroll while the mobile drawer is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const handleNav = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setOpen(false);
  };

  return (
    <header className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">
        <a
          href="#home"
          className="navbar__brand"
          onClick={(e) => handleNav(e, 'home')}
          aria-label="Mahizh Natural Farming — home"
        >
          <Logo
            variant="dark"
            compact={scrolled}
            showMark={false}
            showTamil={false}
          />
        </a>

        <nav
          className={`navbar__nav ${open ? 'is-open' : ''}`}
          aria-label="Primary"
        >
          <ul>
            {LINKS.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  className={active === link.id ? 'is-active' : ''}
                  onClick={(e) => handleNav(e, link.id)}
                  aria-current={active === link.id ? 'page' : undefined}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <button
          className="navbar__toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
        >
          {open ? <FiX /> : <FiMenu />}
        </button>
      </div>

      <button
        className={`navbar__backdrop ${open ? 'is-open' : ''}`}
        onClick={() => setOpen(false)}
        aria-label="Close menu"
        tabIndex={open ? 0 : -1}
      />
    </header>
  );
}
